import React from 'react'

import './styles.scss'
import Attachment from '../Attachment'
import { getFormatedDate } from 'utils'
import MessageStatus from 'components/Chat/MessageStatus'
import Reactions from 'components/Chat/ChatChannels/Reactions'
import FeedReactions from 'components/Chat/FeedReactions'
import { getChannelAndProvider } from 'utils/conversationUtil'
import AvatarImg from 'components/images/AvatarImg'
import DisplayNameMsg from '../DisplayNameMsg'

const CloudAPITemplate = ({
  id,
  type,
  operatorPicture,
  operatorName,
  header,
  user,
  body,
  buttons,
  footer,
  date,
  channelInfo,
  status,
  attachments,
  renderButtons,
  reactions,
  hiddenReaction,
  typeTitle
}) => (
  <div id={id} className={`cloud-api-template cloud-api-template--${type}`}>
    <div className='cloud-api-template__operator-info'>
      <figure className='cloud-api-template__operator-picture'>
        <AvatarImg
          src={operatorPicture}
          alt={operatorName}
        />
      </figure>
      <strong className='cloud-api-template__operator-name text-ellipsis'>
        <DisplayNameMsg
          user={user}
          type={type}
          typeTitle={typeTitle}
          operatorName={operatorName || ''}
        />
      </strong>
      {
        !hiddenReaction ? (
          <FeedReactions
            messageId={id}
            userId={user._id}
            channel={getChannelAndProvider(user)}
            activeReaction={reactions || []}
          />
        ) : null
      }
    </div>
    <div className='cloud-api-template__content'>
      {header ? <p className='cloud-api-template__header'>{header}</p> : null}
      <p className='cloud-api-template__body' dangerouslySetInnerHTML={{ __html: body }} />
      {buttons?.length ? (
        <div className='cloud-api-template__buttons'>{renderButtons(buttons)}</div>
      ) : null}
      {footer ? <p className='cloud-api-template__footer'>{footer}</p> : null}

      <div
        className={`new-message__date new-message__date--right-side cloud-api-template__date`}
      >
        <span>{getFormatedDate({ isoString: date, withTime: true, withYear: true })}</span>

        <MessageStatus
          status={status}
          channel={`${channelInfo.provider}_${channelInfo.channel}`}
        />
      </div>
    </div>
    {
      !hiddenReaction ? (
        <Reactions
          reactions={reactions || []}
          messageId={id}
          userId={user._id}
          channel={getChannelAndProvider(user)}
        />
      ) : null
    }
    {attachments?.length ? (
      <div className='cloud-api-template__attachments'>
        {attachments?.map((attachment, index) => {
          const { fileId, shortUrl, url, urlLong, mimeType, mimeSubtype, thumb, withVirus } = attachment
          return (
            <Attachment
              key={index}
              id={`attachment-${fileId}`}
              url={urlLong || url}
              mimeType={mimeType}
              mimeSubtype={mimeSubtype}
              shortUrl={url || shortUrl}
              thumb={thumb}
              withVirus={withVirus}
            />
          )
        })}
      </div>
    ) : null}
  </div>
)

export default CloudAPITemplate
